// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Uhez","footer":"styles_footer__ywWci"};